const SemVer=require("../classes/semver"),minor=(a,loose)=>new SemVer(a,loose).minor;module.exports=minor;